import React from 'react'
import PropTypes from 'prop-types'
import { outputTypeLabels } from 'i18n/displayConstants/featureOutputs'
import strings from 'utils/strings'
import { CAN } from 'utils/constants'
import { OutputContainer } from './CanoutputSection.style'
import { hexToDecimal } from 'utils/utils'

const CanOutputDetails = ({ mappedOutputId }) => {
  return (
    <div>
      <span>
        <span>{strings.priority}</span>
        <span>{strings.colon_space}</span>
        <strong>{mappedOutputId ? mappedOutputId.slice(0, 2) : '--'}</strong>
      </span>
      <span className="can-output-details">
        <span>{strings.pgn}</span>
        <span>{strings.colon_space}</span>
        <strong>
          {mappedOutputId ? hexToDecimal(mappedOutputId.slice(2, 6)) : '-----'}
        </strong>
      </span>
      <span className="can-output-details">
        <span>{strings.source_address}</span>
        <span>{strings.colon_space}</span>
        <strong>{mappedOutputId ? mappedOutputId.slice(6) : '--'}</strong>
      </span>
    </div>
  )
}

const getOutputLabel = ({ mappedOutputId, numberOfBits }) => {
  if (mappedOutputId) {
    return {
      label: `${outputTypeLabels[CAN]} ${numberOfBits} ${strings.bit}`,
      value: mappedOutputId,
    }
  }

  return null
}

const CanOutputSection = ({
  mappedOutputId,
  numberOfBits,
  showCanId,
  className,
}) => {
  const paramValue = getOutputLabel({
    mappedOutputId,
    numberOfBits,
  })

  return (
    <OutputContainer className={className}>
      {showCanId && (
        <>
          <span>{paramValue.label}</span>
          <span>{strings.colon_space}</span>
          <span>
            <strong>{paramValue.value}</strong>
          </span>
        </>
      )}
      <CanOutputDetails mappedOutputId={mappedOutputId} />
    </OutputContainer>
  )
}

CanOutputSection.propTypes = {
  mappedOutputId: PropTypes.string,
  numberOfBits: PropTypes.number,
  showCanId: PropTypes.bool,
  className: PropTypes.string,
}

export default CanOutputSection
